(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsDatetimepicker', ['$parse', function ($parse) {
    return {
      scope: {
        "wsDatetimepickerOptions": "="
      },
      link: function link(scope, element, attrs) {
        var ngModel = $parse(attrs.ngModel);
        $(function () {
          element.datetimepicker(_.extend({}, {
            onSelect: function onSelect(dateText) {
              scope.$apply(function (scope) {
                // Change binded variable
                ngModel.assign(scope, dateText);
              });
            }
          }, scope.wsDatetimepickerOptions));
        });
      }
    };
  }]);
})();
